package org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.getEndOfHalfYear
import org.hs_soft.runmynesto.domain.util.getEndOfQuarter
import org.hs_soft.runmynesto.domain.util.getEndOfYear
import org.hs_soft.runmynesto.domain.util.getStartOfHalfYear
import org.hs_soft.runmynesto.domain.util.getStartOfQuarter
import org.hs_soft.runmynesto.domain.util.getStartOfYear
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class PeriodYearEnum(
    val from: String,
    val to: String
) {
    ONE_HALF_A_YEAR(
        from = getStartOfYear(0),
        to = getEndOfHalfYear(1)
    ),
    TWO_HALF_A_YEAR(
        from = getStartOfHalfYear(1),
        to = getEndOfYear(0)
    ),
    ONE_QUARTER(
        from = getStartOfQuarter(1),
        to = getEndOfQuarter(1)
    ),
    TWO_QUARTERS(
        from = getStartOfQuarter(2),
        to = getEndOfQuarter(2)
    ),
    THREE_QUARTERS(
        from = getStartOfQuarter(3),
        to = getEndOfQuarter(3)
    ),
    FOUR_QUARTERS(
        from = getStartOfQuarter(4),
        to = getEndOfQuarter(4)
    );

    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            ONE_HALF_A_YEAR -> strings.oneHalfAYear
            TWO_HALF_A_YEAR -> strings.twoHalfAYear
            ONE_QUARTER -> strings.oneQuarter
            TWO_QUARTERS -> strings.twoQuarters
            THREE_QUARTERS -> strings.threeQuarters
            FOUR_QUARTERS -> strings.fourQuarters
        }
    }

    val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                ONE_HALF_A_YEAR -> strings.oneHalfAYear
                TWO_HALF_A_YEAR -> strings.twoHalfAYear
                ONE_QUARTER -> strings.oneQuarter
                TWO_QUARTERS -> strings.twoQuarters
                THREE_QUARTERS -> strings.threeQuarters
                FOUR_QUARTERS -> strings.fourQuarters
            }
        }
}